import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import styles from './NewPassword.module.css';
import { API_BASE } from "../../config/api";

export default function NewPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token'); // Der Reset-Token aus der URL

  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [message, setMessage] = useState('');
const [passwordTouched, setPasswordTouched] = useState(false);

const passwordValidation = {
  length: password.length >= 8,
  uppercase: /[A-Z]/.test(password),
  lowercase: /[a-z]/.test(password),
  number: /[0-9]/.test(password),
  special: /[!@#$%^&*(),.?":{}|<>]/.test(password),
};

  const handleSubmit = async (e: React.FormEvent) => {
  e.preventDefault();
  setMessage("");

  if (password !== confirm) {
    setMessage("Passwords don't match");
    return;
  }

  try {
    const response = await fetch(API_BASE+ "/api/password-update", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ token, password }),
    });

    const result = await response.text();
    setMessage(result);
  } catch (error) {
    setMessage("Error resetting password.");
  }
};

  return (
  <div className={styles.container}>
    <form className={styles.form} onSubmit={handleSubmit}>
      
      <h2 className={styles.title}>Set new password</h2>

      <input
        type="password"
        placeholder="New Password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        onBlur={() => setPasswordTouched(true)}
        required
        className={styles.input}
      />

      <input
        type="password"
        placeholder="Repeat Password"
        value={confirm}
        onChange={(e) => setConfirm(e.target.value)}
        required
        className={styles.input}
      />

      {/* =======================================================
         PASSWORD RULES
         ======================================================= */}
      {passwordTouched && password && (
        <ul className={styles.passwordRules}>
          <li className={passwordValidation.length ? styles.ok : styles.error}>
            At least 8 characters
          </li>

          <li className={passwordValidation.uppercase ? styles.ok : styles.error}>
            At least one uppercase letter
          </li>

          <li className={passwordValidation.lowercase ? styles.ok : styles.error}>
            At least one lowercase letter
          </li>

          <li className={passwordValidation.number ? styles.ok : styles.error}>
            At least one number
          </li>

          <li className={passwordValidation.special ? styles.ok : styles.error}>
            At least one special character (!@#$%^&*(),.?":{}|&lt;&gt;)
          </li>
        </ul>
      )}

      <button type="submit" className={styles.button}>
        Change Password
      </button>

      {message && <p className={styles.message}>{message}</p>}
    </form>
  </div>
);
}